import React from 'react';
import InputWithLabel from'../../base/InputWithLabel/InputWithLabel';
import PropTypes from 'prop-types';

const Amount = ({label,onChange,placeholder,value}) => {

    return (
        <InputWithLabel
            className="col-xs-12"
            id="fault-amount"
            inputDivClassName="col-xs-12 col-sm-6"
            label={label}
            name="amount"
            min={0}
            onChange={onChange}
            placeholder={placeholder}
            type="number"
            value={value} />
    );
};

Amount.propTypes = {
    label:PropTypes.string,
    onChange:PropTypes.func,
    placeholder:PropTypes.string,
}
    

export default Amount;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/Amount/Amount.js